/** Matches a lowercase or uppercase UUID-shaped string, any version. */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Whether a value is the id shape the workspace URL accepts — the single test the URL parser, the
 * share-link builder and the workspace route's access guard apply, so a link is only built from ids the
 * route will read back, and a malformed one is turned away before anything asks the server about it.
 *
 * Deliberately looser than `@efficiently/models`' `isValidUuid`, which pins the version nibble to 1–5
 * and would refuse a v7 id the route itself accepts.
 */
export function isClarityUuid(value: string | null | undefined): value is string {
	return !!value && UUID_RE.test(value);
}
